import React from 'react';

export function InactiveRoom({ message }) {
  return (
    <main className="container d-flex flex-column align-items-center justify-content-center min-vh-100 text-center px-4" style={{ fontFamily: "'Montserrat', sans-serif" }}>
      <div className="card shadow-lg border-0 p-5 rounded-4 bg-white" style={{ maxWidth: '480px' }}>
        <div className="mb-4">
          <i className="bi bi-broadcast text-danger" style={{ fontSize: '4.5rem', animation: 'pulse 2s infinite' }}></i>
        </div>
        <img 
          src="/img/page/xolos-five-bicolor.png" 
          className="mx-auto mb-4" 
          alt="Interaktia Logo" 
          style={{ height: '50px', objectFit: 'contain' }}
        />
        <h2 className="fw-black text-dark mb-3">Sala Inactiva</h2>
        <p className="text-muted fs-6 mb-4">
          {message || 'Esta sala no se encuentra activa en este momento o el evento asociado ha concluido. Por favor, espera a que el operador inicie la dinámica.'}
        </p>
        <div className="d-flex align-items-center justify-content-center gap-2 text-danger fw-bold">
          <span className="spinner-grow spinner-grow-sm" role="status" aria-hidden="true"></span>
          <span>Esperando señal del estadio...</span>
        </div>
      </div>
      
      <style>{`
        @keyframes pulse {
          0% { transform: scale(1); opacity: 1; }
          50% { transform: scale(1.1); opacity: 0.5; }
          100% { transform: scale(1); opacity: 1; }
        }
        .fw-black {
          font-weight: 900;
        }
      `}</style>
    </main>
  );
}
